var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrRobogpDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18504_49938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18504_49938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33073 7.9987V6.66536H10.6641V7.9987H5.33073ZM5.33073 5.33203V3.9987H10.6641V5.33203H5.33073ZM3.9974 9.33203H8.9974C9.31962 9.33203 9.61962 9.40148 9.8974 9.54037C10.1752 9.67925 10.4085 9.87648 10.5974 10.132L11.9974 11.9654V2.66536H3.9974V9.33203ZM3.9974 13.332H11.3641L9.5474 10.9487C9.48073 10.8598 9.40017 10.7904 9.30573 10.7404C9.21128 10.6904 9.10851 10.6654 8.9974 10.6654H3.9974V13.332ZM11.9974 14.6654H3.9974C3.63073 14.6654 3.31684 14.5348 3.05573 14.2737C2.79462 14.0126 2.66406 13.6987 2.66406 13.332V2.66536C2.66406 2.2987 2.79462 1.98481 3.05573 1.7237C3.31684 1.46259 3.63073 1.33203 3.9974 1.33203H11.9974C12.3641 1.33203 12.678 1.46259 12.9391 1.7237C13.2002 1.98481 13.3307 2.2987 13.3307 2.66536V13.332C13.3307 13.6987 13.2002 14.0126 12.9391 14.2737C12.678 14.5348 12.3641 14.6654 11.9974 14.6654Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrRobogpDownload);
export default __webpack_public_path__ + "static/media/br-robogp-download.4f8e7accf5ee13ac7288050a77105d4f.svg";
export { ForwardRef as ReactComponent };